import { Asset, Pill, ReplyIcon } from '@clearcover/atlas';
import React, { FC } from 'react';
import { PageHeaderBar } from 'Shared/components';
import styles from './styles.module.css';

export const HeaderBar: FC<{
  policyId: string;
}> = ({ policyId }) => {
  const returnLink = {
    text: 'Return to active policy',
    href: `/policies/${policyId}`,
  };

  const pillContents = 'Draft';
  const headerText = 'You are viewing a draft';

  return (
    <PageHeaderBar className={styles.headerBar}>
      <Pill className={styles.pill} variant="draft">
        {pillContents}
      </Pill>
      <span className={styles.draftType}>{headerText}</span>
      <span className={styles.dateAndLink}>
        <a
          data-testid="return-to-policy-link"
          href={returnLink.href}
          className={styles.dateAndLinkItem}
        >
          <Asset
            icon={ReplyIcon}
            description="Return to policy"
            height={16}
            width={16}
            className={styles.icon}
          />
          <span>{returnLink.text}</span>
        </a>
      </span>
    </PageHeaderBar>
  );
};
